import { User } from "../domain/User";

export const buildUserAndTeamList = (data: User[]) => {
  // only active users, and useful to sort into alphabetical order now
  const sortedUsers = sortUsers(data);

  const teams = getListOfTeams(sortedUsers).map((team) => ({
    id: team.id,
    label: team.name,
  }));

  const users = data.map((user) => ({
    id: user.upn,
    label: user.fullName ?? user.upn,
    teams: user.userTeams,
  }));

  return { users, teams };
};

export const sortUsers = (users: User[]) =>
  users.sort((a, b) => (a.fullName > b.fullName ? 1 : -1));

const getListOfTeams = (data: User[]) => {
  const arrayOfTeamArrays = data.map((item) =>
    item.userTeams.map((team) => ({
      id: team.id,
      name: team.name,
    }))
  );

  const teams = arrayOfTeamArrays
    .flat()
    .reduce((acc, curr) => {
      if (acc.some((existingItem) => existingItem.id === curr.id)) {
        return acc;
      }
      return [curr, ...acc];
    }, [] as User["userTeams"])
    .sort((a, b) => (a.name > b.name ? 1 : -1));

  return teams;
};
